/* ═══════════════════════════════════════════════════════════════════
   ZERO GRAVITY POOL — Physics Engine + WebGL Water Ripple
   Matter.js bodies synced to DOM cards via transform matrices.
   WebGL shader ported from 21st.dev water-ripple-image component.
   ═══════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ═══════════════════════════════════════════
     PART 1: WebGL WATER RIPPLE SHADER
     ═══════════════════════════════════════════ */

  var VERT = [
    'precision mediump float;',
    'varying vec2 vUv;',
    'attribute vec2 a_position;',
    'void main() {',
    '  vUv = .5 * (a_position + 1.);',
    '  gl_Position = vec4(a_position, 0.0, 1.0);',
    '}'
  ].join('\n');

  var FRAG = [
    'precision mediump float;',
    '',
    'varying vec2 vUv;',
    'uniform sampler2D u_image_texture;',
    'uniform float u_time;',
    'uniform float u_ratio;',
    'uniform float u_img_ratio;',
    'uniform float u_blueish;',
    'uniform float u_scale;',
    'uniform float u_illumination;',
    'uniform float u_surface_distortion;',
    'uniform float u_water_distortion;',
    '',
    'vec3 mod289(vec3 x) { return x - floor(x * (1. / 289.)) * 289.; }',
    'vec2 mod289(vec2 x) { return x - floor(x * (1. / 289.)) * 289.; }',
    'vec3 permute(vec3 x) { return mod289(((x*34.)+1.)*x); }',
    'float snoise(vec2 v) {',
    '  const vec4 C = vec4(0.211324865405187, 0.366025403784439, -0.577350269189626, 0.024390243902439);',
    '  vec2 i = floor(v + dot(v, C.yy));',
    '  vec2 x0 = v - i + dot(i, C.xx);',
    '  vec2 i1;',
    '  i1 = (x0.x > x0.y) ? vec2(1., 0.) : vec2(0., 1.);',
    '  vec4 x12 = x0.xyxy + C.xxzz;',
    '  x12.xy -= i1;',
    '  i = mod289(i);',
    '  vec3 p = permute(permute(i.y + vec3(0., i1.y, 1.)) + i.x + vec3(0., i1.x, 1.));',
    '  vec3 m = max(0.5 - vec3(dot(x0, x0), dot(x12.xy, x12.xy), dot(x12.zw, x12.zw)), 0.);',
    '  m = m*m;',
    '  m = m*m;',
    '  vec3 x = 2. * fract(p * C.www) - 1.;',
    '  vec3 h = abs(x) - 0.5;',
    '  vec3 ox = floor(x + 0.5);',
    '  vec3 a0 = x - ox;',
    '  m *= 1.79284291400159 - 0.85373472095314 * (a0*a0 + h*h);',
    '  vec3 g;',
    '  g.x = a0.x * x0.x + h.x * x0.y;',
    '  g.yz = a0.yz * x12.xz + h.yz * x12.yw;',
    '  return 130. * dot(m, g);',
    '}',
    '',
    'mat2 rotate2D(float r) {',
    '  return mat2(cos(r), sin(r), -sin(r), cos(r));',
    '}',
    '',
    'float surface_noise(vec2 uv, float t, float scale) {',
    '  vec2 n = vec2(.1);',
    '  vec2 N = vec2(.1);',
    '  mat2 m = rotate2D(.5);',
    '  for (int j = 0; j < 10; j++) {',
    '    uv *= m;',
    '    n *= m;',
    '    vec2 q = uv * scale + float(j) + n + (.5 + .5 * float(j)) * (mod(float(j), 2.) - 1.) * t;',
    '    n += sin(q);',
    '    N += cos(q) / scale;',
    '    scale *= 1.2;',
    '  }',
    '  return (N.x + N.y + .1);',
    '}',
    '',
    'void main() {',
    '  vec2 uv = vUv;',
    '  uv.y = 1. - uv.y;',
    '  uv.x *= u_ratio;',
    '',
    '  float t = .002 * u_time;',
    '  vec3 color = vec3(0.);',
    '  float opacity = 0.;',
    '',
    '  float outer_noise = snoise((.3 + .1 * sin(t)) * uv + vec2(0., .2 * t));',
    '  vec2 surface_noise_uv = 2. * uv + (outer_noise * .2);',
    '',
    '  float surf = surface_noise(surface_noise_uv, t, u_scale);',
    '  surf *= pow(uv.y, .3);',
    '  surf = pow(surf, 2.);',
    '',
    '  vec2 img_uv = vUv;',
    '  img_uv -= .5;',
    '  if (u_ratio > u_img_ratio) {',
    '    img_uv.x = img_uv.x * u_ratio / u_img_ratio;',
    '  } else {',
    '    img_uv.y = img_uv.y * u_img_ratio / u_ratio;',
    '  }',
    '  float scale_factor = 1.1;',
    '  img_uv *= scale_factor;',
    '  img_uv += .5;',
    '  img_uv.y = 1. - img_uv.y;',
    '',
    '  img_uv += (u_water_distortion * outer_noise);',
    '  img_uv += (u_surface_distortion * surf);',
    '',
    '  vec4 img = texture2D(u_image_texture, img_uv);',
    '  img *= (1. + u_illumination * surf);',
    '',
    '  color += img.rgb;',
    '  color += u_illumination * vec3(1. - u_blueish, 1., 1.) * surf;',
    '  opacity += img.a;',
    '',
    '  float edge_width = .02;',
    '  float edge_alpha = smoothstep(0., edge_width, img_uv.x) * smoothstep(1., 1. - edge_width, img_uv.x);',
    '  edge_alpha *= smoothstep(0., edge_width, img_uv.y) * smoothstep(1., 1. - edge_width, img_uv.y);',
    '  color *= edge_alpha;',
    '  opacity *= edge_alpha;',
    '',
    '  gl_FragColor = vec4(color, opacity);',
    '}'
  ].join('\n');

  /* ──── GL helpers ──── */

  function compileShader(gl, src, type) {
    var sh = gl.createShader(type);
    gl.shaderSource(sh, src);
    gl.compileShader(sh);
    if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) {
      console.error('[zgp-water] Shader error:', gl.getShaderInfoLog(sh));
      gl.deleteShader(sh);
      return null;
    }
    return sh;
  }

  function createGLProgram(gl, vs, fs) {
    var v = compileShader(gl, vs, gl.VERTEX_SHADER);
    var f = compileShader(gl, fs, gl.FRAGMENT_SHADER);
    if (!v || !f) return null;
    var prog = gl.createProgram();
    gl.attachShader(prog, v);
    gl.attachShader(prog, f);
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) {
      console.error('[zgp-water] Program link error:', gl.getProgramInfoLog(prog));
      gl.deleteProgram(prog);
      return null;
    }
    return prog;
  }

  /* ──── Parse hex color ──── */

  function hexToRgb(hex) {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return { r: r, g: g, b: b };
  }

  function lightenRgb(rgb, amount) {
    return {
      r: Math.min(255, Math.round(rgb.r + (255 - rgb.r) * amount)),
      g: Math.min(255, Math.round(rgb.g + (255 - rgb.g) * amount)),
      b: Math.min(255, Math.round(rgb.b + (255 - rgb.b) * amount))
    };
  }

  /* ──── Build offscreen texture ──── */

  function buildTextureCanvas(section) {
    var data = section.dataset;
    var w = Math.max(section.offsetWidth, 800);
    var h = Math.max(section.offsetHeight, 600);
    var dpr = Math.min(window.devicePixelRatio || 1, 2);

    var off = document.createElement('canvas');
    off.width = w * dpr;
    off.height = h * dpr;
    var ctx = off.getContext('2d');
    ctx.scale(dpr, dpr);

    /* Water gradient background */
    var topColor = hexToRgb(data.zgpWaterTop || '#6FD8E0');
    var bottomColor = hexToRgb(data.zgpWaterBottom || '#0E6B8A');
    var lighterTop = lightenRgb(topColor, 0.15);

    var grad = ctx.createLinearGradient(0, 0, 0, h);
    grad.addColorStop(0, 'rgb(' + lighterTop.r + ',' + lighterTop.g + ',' + lighterTop.b + ')');
    grad.addColorStop(0.35, 'rgb(' + topColor.r + ',' + topColor.g + ',' + topColor.b + ')');
    grad.addColorStop(1, 'rgb(' + bottomColor.r + ',' + bottomColor.g + ',' + bottomColor.b + ')');
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, w, h);

    /* Subtle tile grid lines */
    ctx.strokeStyle = 'rgba(255,255,255,0.07)';
    ctx.lineWidth = 1;
    var gridSize = 80;
    for (var gx = 0; gx <= w; gx += gridSize) {
      ctx.beginPath(); ctx.moveTo(gx, 0); ctx.lineTo(gx, h); ctx.stroke();
    }
    for (var gy = 0; gy <= h; gy += gridSize) {
      ctx.beginPath(); ctx.moveTo(0, gy); ctx.lineTo(w, gy); ctx.stroke();
    }

    /* Floor text */
    var text = data.zgpFloorText || 'AFEWPIECES';
    var textColor = data.zgpTextColor || '#0A0A0A';
    var textSize = parseInt(data.zgpTextSize, 10) || 200;
    var textSpacing = parseInt(data.zgpTextSpacing, 10) || -4;
    var textFont = data.zgpTextFont || 'display';

    var scaledSize = textSize * (w / 1440);
    scaledSize = Math.max(40, Math.min(scaledSize, w * 0.25));

    var fontFamily = textFont === 'mono'
      ? "'Space Mono', 'Courier New', Courier, monospace"
      : "'Helvetica Neue', 'Arial Black', Helvetica, Arial, sans-serif";

    ctx.save();
    ctx.font = '900 ' + scaledSize + 'px ' + fontFamily;
    ctx.fillStyle = textColor;
    ctx.globalAlpha = 0.92;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';

    var textY = h - (h * 0.08);

    if (textSpacing !== 0) {
      var chars = text.split('');
      var totalWidth = 0;
      chars.forEach(function (ch) {
        totalWidth += ctx.measureText(ch).width + textSpacing;
      });
      totalWidth -= textSpacing;

      var startX = (w - totalWidth) / 2;
      chars.forEach(function (ch) {
        var chW = ctx.measureText(ch).width;
        ctx.fillText(ch, startX + chW / 2, textY);
        startX += chW + textSpacing;
      });
    } else {
      ctx.fillText(text, w / 2, textY);
    }
    ctx.restore();

    return off;
  }

  /* ──── Water class ──── */

  function ZeroGravityWater(section) {
    this.section = section;
    this.canvas = section.querySelector('[data-zgp-water]');
    if (!this.canvas) { console.warn('[zgp-water] No canvas element found'); return; }

    this.gl = null;
    this.program = null;
    this.uniforms = {};
    this.texture = null;
    this.waterAnimId = null;
    this.dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.hasRendered = false;

    this.params = {
      blueish: parseFloat(section.dataset.zgpBlueish) || 0.5,
      scale: parseFloat(section.dataset.zgpScale) || 7,
      illumination: parseFloat(section.dataset.zgpIllumination) || 0.15,
      surfaceDistortion: parseFloat(section.dataset.zgpSurfaceDistortion) || 0.05,
      waterDistortion: parseFloat(section.dataset.zgpWaterDistortion) || 0.03,
    };

    console.log('[zgp-water] Initializing with params:', this.params);
    console.log('[zgp-water] Section dimensions:', section.offsetWidth, 'x', section.offsetHeight);
    console.log('[zgp-water] Data attributes:', JSON.stringify(section.dataset));

    // Ensure section has dimensions — if not, defer
    if (section.offsetWidth === 0 || section.offsetHeight === 0) {
      console.warn('[zgp-water] Section has no dimensions, deferring init');
      var self = this;
      setTimeout(function() { new ZeroGravityWater(section); }, 200);
      return;
    }

    if (!this._initGL()) {
      console.warn('[zgp-water] WebGL init failed, using CSS fallback');
      this.canvas.style.display = 'none';
      return;
    }
    this._buildTexture();
    this._resize();
    this._startWater();
  }

  ZeroGravityWater.prototype._initGL = function () {
    var gl = this.canvas.getContext('webgl', { alpha: false, antialias: false, preserveDrawingBuffer: false })
          || this.canvas.getContext('experimental-webgl', { alpha: false, antialias: false });
    if (!gl) return false;
    this.gl = gl;

    var program = createGLProgram(gl, VERT, FRAG);
    if (!program) return false;
    this.program = program;
    gl.useProgram(program);

    var count = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
    for (var i = 0; i < count; i++) {
      var info = gl.getActiveUniform(program, i);
      if (info) this.uniforms[info.name] = gl.getUniformLocation(program, info.name);
    }

    var vertices = new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]);
    var vbo = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, vbo);
    gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);
    var posLoc = gl.getAttribLocation(program, 'a_position');
    gl.enableVertexAttribArray(posLoc);
    gl.vertexAttribPointer(posLoc, 2, gl.FLOAT, false, 0, 0);

    gl.uniform1f(this.uniforms['u_blueish'], this.params.blueish);
    gl.uniform1f(this.uniforms['u_scale'], this.params.scale);
    gl.uniform1f(this.uniforms['u_illumination'], this.params.illumination);
    gl.uniform1f(this.uniforms['u_surface_distortion'], this.params.surfaceDistortion);
    gl.uniform1f(this.uniforms['u_water_distortion'], this.params.waterDistortion);

    return true;
  };

  ZeroGravityWater.prototype._buildTexture = function () {
    var gl = this.gl;
    var offCanvas = buildTextureCanvas(this.section);

    if (this.texture) gl.deleteTexture(this.texture);
    var tex = gl.createTexture();
    this.texture = tex;
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 0);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, offCanvas);

    gl.uniform1i(this.uniforms['u_image_texture'], 0);
    gl.uniform1f(this.uniforms['u_img_ratio'], offCanvas.width / offCanvas.height);
  };

  ZeroGravityWater.prototype._resize = function () {
    var gl = this.gl;
    var c = this.canvas;
    var w = Math.floor(this.section.offsetWidth * this.dpr);
    var h = Math.floor(this.section.offsetHeight * this.dpr);
    if (c.width !== w || c.height !== h) {
      c.width = w;
      c.height = h;
    }
    c.style.width = this.section.offsetWidth + 'px';
    c.style.height = this.section.offsetHeight + 'px';
    gl.viewport(0, 0, c.width, c.height);
    gl.uniform1f(this.uniforms['u_ratio'], c.width / c.height);
  };

  ZeroGravityWater.prototype._startWater = function () {
    if (this.waterAnimId) return;
    var self = this;
    console.log('[zgp-water] Starting render loop');
    function render() {
      var gl = self.gl;
      if (self.uniforms['u_time']) {
        gl.uniform1f(self.uniforms['u_time'], performance.now());
      }
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      if (!self.hasRendered) {
        self.hasRendered = true;
        self.canvas.classList.add('zgp__water-canvas--active');
        console.log('[zgp-water] First frame rendered — canvas visible');
      }
      self.waterAnimId = requestAnimationFrame(render);
    }
    this.waterAnimId = requestAnimationFrame(render);
  };

  ZeroGravityWater.prototype._stopWater = function () {
    if (this.waterAnimId) {
      cancelAnimationFrame(this.waterAnimId);
      this.waterAnimId = null;
    }
  };


  /* ═══════════════════════════════════════════
     PART 2: MATTER.JS ZERO-GRAVITY PHYSICS
     ═══════════════════════════════════════════ */

  function ZeroGravityPool(root) {
    this.root = root;
    this.stage = root.querySelector('[data-zgp-stage]');
    this.cards = Array.from(root.querySelectorAll('[data-zgp-card]'));
    if (!this.stage || this.cards.length === 0) return;

    this.M = Matter;
    this.engine = Matter.Engine.create({
      enableSleeping: false,
      gravity: { x: 0, y: 0, scale: 0 },
    });
    this.world = this.engine.world;

    this.bounds = this._readBounds();
    this.bodies = [];
    this.walls = [];
    this._cachedCardSize = null;

    this._createWalls();
    this._createBodies();
    this._bindCards();
    this._bindResize();
    this._bindVisibility();

    this._raf = null;
    this._lastFrame = performance.now();
    this._step = this._step.bind(this);
    this._start();
  }

  ZeroGravityPool.prototype._readBounds = function () {
    var rect = this.root.getBoundingClientRect();
    return { width: rect.width, height: rect.height, reservedBottom: 0 };
  };

  ZeroGravityPool.prototype._cardSize = function () {
    if (this._cachedCardSize) return this._cachedCardSize;
    var sample = this.cards[0];
    var prev = sample.style.transform;
    sample.style.transform = 'translate3d(0,0,0)';
    var r = sample.getBoundingClientRect();
    sample.style.transform = prev;
    this._cachedCardSize = { w: r.width || 200, h: r.height || 264 };
    return this._cachedCardSize;
  };

  ZeroGravityPool.prototype._createWalls = function () {
    var Bodies = this.M.Bodies, World = this.M.World, self = this;
    this.walls.forEach(function (w) { World.remove(self.world, w); });
    this.walls = [];
    var W = this.bounds.width, H = this.bounds.height, t = 80;
    var opts = { isStatic: true, restitution: 0.8, friction: 0 };
    var walls = [
      Bodies.rectangle(W / 2, -t / 2, W + t * 2, t, opts),
      Bodies.rectangle(W / 2, H + t / 2, W + t * 2, t, opts),
      Bodies.rectangle(-t / 2, H / 2, t, H * 2, opts),
      Bodies.rectangle(W + t / 2, H / 2, t, H * 2, opts),
    ];
    walls.forEach(function (w) { World.add(self.world, w); });
    this.walls = walls;
  };

  ZeroGravityPool.prototype._createBodies = function () {
    var Bodies = this.M.Bodies, World = this.M.World, Body = this.M.Body;
    var W = this.bounds.width, H = this.bounds.height;
    var size = this._cardSize(), w = size.w, h = size.h;
    var cols = Math.min(this.cards.length, 4);
    var rows = Math.ceil(this.cards.length / cols);
    var cellW = W / (cols + 1), cellH = H / (rows + 1);
    var self = this;

    this.cards.forEach(function (card, i) {
      var col = i % cols, row = Math.floor(i / cols);
      var x = cellW * (col + 1) + (Math.random() - 0.5) * cellW * 0.4;
      var y = cellH * (row + 1) + (Math.random() - 0.5) * cellH * 0.4;

      var body = Bodies.rectangle(x, y, w, h, {
        frictionAir: 0.003,
        restitution: 0.7,
        density: 0.001,
        inertia: Infinity,
        inverseInertia: 0,
        chamfer: { radius: 6 },
        label: 'zgp-card-' + i,
      });

      var angle = Math.random() * Math.PI * 2;
      var speed = 1.5 + Math.random() * 2.0;
      Body.setVelocity(body, { x: Math.cos(angle) * speed, y: Math.sin(angle) * speed });
      Body.setAngle(body, (Math.random() - 0.5) * 0.15);

      World.add(self.world, body);
      self.bodies.push(body);
      card.__zgpBody = body;
      card.__zgpIndex = i;
    });
  };

  ZeroGravityPool.prototype._bindCards = function () {
    var Body = this.M.Body;
    this.cards.forEach(function (card) {
      var body = card.__zgpBody;
      var pin = function () {
        if (!body) return;
        card.dataset.static = 'true';
        Body.setVelocity(body, { x: 0, y: 0 });
        Body.setAngularVelocity(body, 0);
        body.__zgpFrozen = true;
      };
      var release = function () {
        if (!body) return;
        card.dataset.static = 'false';
        body.__zgpFrozen = false;
        var a = Math.random() * Math.PI * 2;
        Body.applyForce(body, body.position, { x: Math.cos(a) * 0.015, y: Math.sin(a) * 0.015 });
      };
      card.addEventListener('mouseenter', pin);
      card.addEventListener('mouseleave', release);
      card.addEventListener('focusin', pin);
      card.addEventListener('focusout', release);
      card.addEventListener('touchstart', pin, { passive: true });
      card.addEventListener('touchend', function () { setTimeout(release, 800); }, { passive: true });
    });
  };

  ZeroGravityPool.prototype._start = function () {
    if (this._raf) return;
    this._lastFrame = performance.now();
    this._raf = requestAnimationFrame(this._step);
  };

  ZeroGravityPool.prototype._stop = function () {
    if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
  };

  ZeroGravityPool.prototype._step = function (now) {
    var dt = Math.min(32, now - this._lastFrame);
    this._lastFrame = now;
    this.M.Engine.update(this.engine, dt);

    for (var i = 0; i < this.bodies.length; i++) {
      var body = this.bodies[i];
      if (body.__zgpFrozen) continue;

      var t = now * 0.0004 + i * 2.3;
      var fx = Math.sin(t) * 0.00035;
      var fy = Math.cos(t * 0.87) * 0.00035;
      this.M.Body.applyForce(body, body.position, { x: fx, y: fy });

      var v = body.velocity;
      var speed = Math.sqrt(v.x * v.x + v.y * v.y);
      if (speed < 0.3) {
        var na = Math.random() * Math.PI * 2;
        this.M.Body.applyForce(body, body.position, { x: Math.cos(na) * 0.001, y: Math.sin(na) * 0.001 });
      }

      var maxV = 3.5;
      if (v.x > maxV) this.M.Body.setVelocity(body, { x: maxV, y: v.y });
      if (v.x < -maxV) this.M.Body.setVelocity(body, { x: -maxV, y: v.y });
      if (v.y > maxV) this.M.Body.setVelocity(body, { x: v.x, y: maxV });
      if (v.y < -maxV) this.M.Body.setVelocity(body, { x: v.x, y: -maxV });
    }

    var size = this._cardSize(), halfW = size.w / 2, halfH = size.h / 2;
    for (var j = 0; j < this.cards.length; j++) {
      var card = this.cards[j];
      var b = this.bodies[j];
      var x = b.position.x - halfW;
      var y = b.position.y - halfH;
      var deg = b.angle * 57.29578;
      card.style.transform = 'translate3d(' + x.toFixed(2) + 'px, ' + y.toFixed(2) + 'px, 0) rotate(' + deg.toFixed(2) + 'deg)';
    }

    this._raf = requestAnimationFrame(this._step);
  };

  ZeroGravityPool.prototype._bindResize = function () {
    var self = this, timeout;
    window.addEventListener('resize', function () {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        self._cachedCardSize = null;
        self.bounds = self._readBounds();
        self._createWalls();
        var W = self.bounds.width, H = self.bounds.height, sz = self._cardSize();
        self.bodies.forEach(function (b) {
          self.M.Body.setPosition(b, {
            x: Math.max(sz.w / 2, Math.min(W - sz.w / 2, b.position.x)),
            y: Math.max(sz.h / 2, Math.min(H - sz.h / 2, b.position.y)),
          });
        });
      }, 150);
    });
  };

  ZeroGravityPool.prototype._bindVisibility = function () {
    var self = this;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self._stop(); else self._start();
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) self._start(); else self._stop(); });
      }, { threshold: 0.05 });
      io.observe(this.root);
    }
  };


  /* ═══════════════════════════════════════════
     PART 3: INIT — boot both water + physics
     ═══════════════════════════════════════════ */

  function init() {
    if (typeof Matter === 'undefined') {
      console.warn('[zgp] Matter.js not loaded yet — retrying');
      return setTimeout(init, 50);
    }

    var sections = document.querySelectorAll('[data-zgp]');
    sections.forEach(function (section) {
      if (section.__zgpBooted) return;
      section.__zgpBooted = true;

      // Boot water first, then physics
      new ZeroGravityWater(section);
      new ZeroGravityPool(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
